// This is a simple in memory cache (For this PWA version, we don't use Pinia or some other more sophisticated cache solution for the sake of simpleness)
// In the future we may want a better solution, so this is not a reference
// This is not thread safe

import Api from "api-client";

export function getCurrencies() {
    return getOrCompute("currencies", async () => {
        return JSON.stringify((await Api.getCurrencies()).data);
    });
}

async function getOrCompute(key, computeFnc) {
    let cachedValue = localStorage.getItem(key);
    if (cachedValue) {
        return cachedValue; // We found the value in cache
    }

    // If we reached this code segment there is a cache miss
    console.log("Cache miss for: " + key);

    try {
        let computedValue = await computeFnc();
        localStorage.setItem(key, computedValue);
        return computedValue;
    } catch (error) {
        console.error("Error computing value for key " + key + ": ", error);
        return Promise.reject(error);
    }
}